var _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLoadingSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 18,
  fill: "none",
  strokeWidth: 4,
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stroke-dasharray",
  from: "1,280",
  to: "89,280",
  dur: "1.5s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "stroke-dashoffset",
  from: 0,
  to: -140,
  dur: "1.5s",
  repeatCount: "indefinite"
}))));

export default SvgLoadingSpinner;